module.exports = __webpack_public_path__ + "static/media/regular.580d0778.ttf";